module.exports = __webpack_public_path__ + "img/menu-avril.2e00ab0d.webp";